/**
 * @desc 查询操作日志的用户列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.QueryOperationLogConditions,
): Promise<defs.StandardReturn<defs.Pager<defs.OperateLogDTO>>> {
  return defHttp.post({
    url: '/web/notify/queryLog',
    data,
  });
}

export function mock(
  data: defs.QueryOperationLogConditions,
): Promise<defs.StandardReturn<defs.Pager<defs.OperateLogDTO>>> {
  return defHttp.post({
    url: '/mock/web/notify/queryLog',
    data,
  });
}
